/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import type { SuccessFetch } from "types";
import { useApi } from "utils";

type Response = SuccessFetch<{ payload: { nextcode: string } }>;

export const useCode = (varTgl: string, enabled: boolean, submitCount: number) => {
  const api = useApi();
  const [data, setData] = useState<string>("-");

  useEffect(() => {
    if (enabled) {
      api
        .post("/transfermoney/getnewtrxcode", {
          vartgl: varTgl
        })
        .then((res: Response) => {
          setData(res.data.payload.nextcode);
        });
    }
  }, [varTgl, submitCount]);

  return { data };
};
